import React, { useState, useContext, useReducer } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";
import * as TipoDeError from "../../isp._comun/services/Errores";
// import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";
import ServiceQueryClientes from "../../isp.žapi.clientes/ServiceQueryClientes";
import QueryClienteReducer from "../reductores/QueryClienteReducer";
import CargaDeClientesBuscados from "../reductores/acciones/dispatch/CargaDeClientesBuscados";
import FinalizarComando from "../../isp.iu.contratos/reductores/acciones/dispatch/FinalizarComando";
import DialogoSeleccionarClienteLayout from "./layouts/DialogoSeleccionarClienteLayout";
import ComandoAPI from "../../isp._comun/iu/componentes/ComandoAPI";

// import { NotificacionToastDeError } from "../../../all/componentes/widgets/Notificaciones";

// import CodigoDeError from "../../../all/presentadores/CodigosDeErrorDeRespuestas.json";
// import DataDeRespuestas_Comun from "../../../all/presentadores/DataEstaticaDeRespuestas.json";
// import DataDeRespuestas_Facturacion from "../../servicios/DataEstaticaDeRespuestas.json";

// import ServicioDeQueryDeUnClienteAFacturar from "../../servicios/ServicioDeQueryDeUnClienteAFacturar";

const DialogoSeleccionarCliente = ({ ventana }) => {
    const { notificar, handleErroresExtraEnPrincipal } = useContext(GlobalContext);

    const [estadoQ, dispatchQ] = useReducer(QueryClienteReducer, {
        data: [],
        params: {},
        flag: {
            procesandoComando: true,
            procesandoBusquedaUnSoloCliente: false,
        },
        // idClienteSelec: null,
    });


    const ServicioApiQueryClientes = new ServiceQueryClientes();
    const buscarClientesCommand = new ComandoAPI(ServicioApiQueryClientes);
    buscarClientesCommand.ejecutar = async (paramsQuery) => {
        /* const clienteAFactPorActualizar = {
            id: estadoDCF.domain.screen.idCliente,
            data: estadoDCF.domain.update,
        }; */

        try {
            const respuestaQuery = await ServicioApiQueryClientes.ejecutar(paramsQuery);
            dispatchQ(new CargaDeClientesBuscados(respuestaQuery.clientes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new FinalizarComando());
            }
            handleErroresExtraEnPrincipal(error);
        }
    };

    return (
        <DialogoSeleccionarClienteLayout
            ventana={ventana}
            dispatchQ={dispatchQ}
            estadoQ={estadoQ}
            buscarClientesCommand={buscarClientesCommand}
        />
    );
};

export default DialogoSeleccionarCliente;
